<template>
  <div class="products-dms-page-content flex flex-col items-center w-full text-left">
    <section class="relative w-full flex flex-col items-center max-ml:hidden">
      <Pic class="w-full relative z-0 min-h-20rem max-ml:object-cover max-ml:object-center "
        src="/images/pages/products/dms/banner.png" alt="" />
      <PageContentCenter class="text-[#7D838D] absolute top-[160px]">
        <h2 class="text-42.08px text-[#1F2329] mb-[2rem] font-semibold max-ml:text-2rem max-ml:mb-[1rem]">
          DMS经销渠道管理平台
        </h2>
        <p class="">助力品牌商实现全渠道&全场景业务管理闭环</p>
      </PageContentCenter>
    </section>

    <section class="ml:hidden w-full">
      <Pic class="w-full" src="/images/mobile/products/dms.png"></Pic>
    </section>

    <section
      class="relative w-full flex flex-col items-center dms-product-cover pt-[4.19rem] pb-[4.69rem] max-ml:w-100% max-ml:h-auto">
      <PageContentCenter class="color-[#FFFFFF] text-center mb-[3.56rem]">
        <h2 class="text-2.1rem  mb-[1.25rem] text-[#FFFFFF] font-400">
          DMS+DP+F2B
        </h2>
        <p class="">助力品牌商实现全渠道&全场景业务管理闭环</p>
      </PageContentCenter>
      <Pic class="w-[75.2rem] h-[56.28rem] relative z-0  max-ml:w-100% max-ml:h-auto"
        src="/images/pages/products/dms/Group 1171275055@2x.png" alt="" />
    </section>
    <section class="relative w-full flex flex-col items-center bg-[#ECF3FD] max-ml:hidden">
      <PageContentCenter class="text-[#1F2329] text-center mt-[5rem]">
        <p class="text-[2.13rem]">助力渠道数智化升级</p>
      </PageContentCenter>
      <div class="w-full flex flex-row items-center">
        <div class="flex-1 flex justify-end ">
          <div class="flex flex-col w-[40rem] width-[60%]">
            <div class="color-[#272E3B] text-[1em]">
              <div class="indent-8">
                快消品作为充分竞争市场，在中国城乡二元结构下，品牌仍需依赖经销渠道进行铺货、触达目标客户
              </div>
              <div class="indent-8">
                在品牌、多级经销共存的模式下，如何转型渠道合作模式，获取更准确的终端（b/C）需求、了解渠道的库存和动销情况，帮助渠道提升市场拓展、客户及需求管理能力、库存周转率，是品牌商发力渠道升级的方向。
              </div>
            </div>
            <div class="flex flex-row justify-between mt-[4.19rem] pr-[11.25rem] ">
              <div class="w-8rem text-center flex flex-col items-center justify-center">
                <Pic class="w-[3.75rem] h-[3.75rem] relative z-0 flex-shrink-0 "
                  src="/images/pages/products/dms/产品介绍-数据实时化@2x.png" alt="" />
                <div class="color-[#272E3B] text-[0.88rem]">数据实时化</div>
              </div>
              <div class="w-8rem text-center flex flex-col items-center justify-center">
                <Pic class="w-[3.75rem] h-[3.75rem] relative z-0 flex-shrink-0 "
                  src="/images/pages/products/dms/产品介绍-流程自动化@2x.png" alt="" />
                <div class="color-[#272E3B] text-[0.88rem]">流程自动化</div>
              </div>
              <div class="w-8rem text-center flex flex-col items-center justify-center">
                <Pic class="w-[3.75rem] h-[3.75rem] relative z-0 flex-shrink-0 max-ml:w-100% max-ml:h-auto"
                  src="/images/pages/products/dms/产品介绍-协同透明化@2x.png" alt="" />
                <div class="color-[#272E3B] text-[0.88rem]">协同透明化</div>
              </div>
              <div class="w-8rem text-center flex flex-col items-center justify-center">
                <Pic class="w-[3.75rem] h-[3.75rem] relative z-0 flex-shrink-0 max-ml:w-100% max-ml:h-auto"
                  src="/images/pages/products/dms/产品介绍-决策智能化@2x.png" alt="" />
                <div class="color-[#272E3B] text-[0.88rem]">决策智能化</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1 justify-start">
          <Pic class="w-[56rem] h-[46.75rem] relative z-0 flex-shrink-0 max-ml:w-100% max-ml:h-auto"
            src="/images/pages/products/dms/Mask group@2x.png" alt="" />
        </div>
      </div>
    </section>
    <section class="relative w-full flex flex-col items-center bg-[#02144d] max-ml:hidden">
      <PageContentCenter class="text-[#fff] text-center mt-[5rem] pb-3.5rem">
        <p class="text-[2.13rem]">产品架构</p>
      </PageContentCenter>
      <Pic class="w-120rem h-auto relative z-0" src="/images/pages/products/dms/Group 1171275009@2x (1).png" alt="" />
    </section>

    <section class="w-full">
      <h2 class="text-[2rem] text-[#272E3B] pt-[80px] font-bold bg-[#EFF7FF]">
        <PageContentCenter class="text-center clolr-[#272E3B] text-[2rem]">
          {{ content.featuresIntroduction.title }}
        </PageContentCenter>
      </h2>

      <section :class="[
        'py-3.56rem',
        group.direction === 'copywriting-to-image' ? 'bg-[#EFF7FF]' : '',
      ]" v-for="group in content.featuresIntroduction.groups">
        <PageContentCenter
          :class="[
            'flex', 'justify-center', 'gap-160px', 'relative',
            group.direction === 'image-to-copywriting' ? 'ml:flex-row-reverse' : '', 'max-ml:flex-col!', 'max-ml:gap-20px']">
          <div class="w-350px relative top-1/2 align-self-center max-ml:w-100%">
            <div :class="['mb-1.75rem']">
              <Pic :src="group.icon" class="w-[5.5rem] h-[5rem] mb-1.75rem max-ml:w-20% max-ml:h-auto max-ml:hidden">
              </Pic>
              <h4 class="text-1.88rem">{{ group.title }}</h4>
            </div>
            <ul class="features-group-ul ">
              <li v-for="desc in group.descList" class="text-[#616671] text-[1rem] mb-[2rem] features-group-li">
                {{ desc }}
              </li>
            </ul>
          </div>
          <Pic class="w-42.25rem max-ml:w-100%" :src="group.mainImage" :style="{}"></Pic>
        </PageContentCenter>
      </section>
    </section>

    <!-- <section class="relative w-full mdsy-product-advantage">
      <Pic
        class="w-full relative z-0 min-heght-[30.75rem]"
        src="/images/pages/products/dms/Frame 1171275056@2x.png"
        alt=""
      />
      <div
        class="text-center pt-[60px] color-[#1F2329] text-[2.13rem] absolute top-0 w-full"
      >
        {{ content.advantage.title }}
      </div>
      <div class="absolute top-14% z-10">
        <PageContentCenter>
          <div
            v-for="(item, index) in content.advantage.list"
            class="mdsy-product-advantage-item relative flex flex-row"
          >
            <div class="mdsy-product-advantage-content flex flex-row mb-4.7rem">
              <div class="color-#fff pl-2.63rem pt-2.19rem w-16.38rem">
                <div class="text-[3.38rem] relative">
                  {{ item.pre }}
                  <span class="text-[1.5rem] relative left--8px">%</span>
                  <div
                    class="mdsy-product-advantage-icon inline-block relative"
                    :class="index > 0 ? 'rotate-180' : ''"
                  ></div>
                </div>
                <div class="text-[1.25rem] pt-[1.13rem]">{{ item.desc }}</div>
              </div>
              <ul class="pl-2.8rem pt-2.5rem features-group-ul text-[1rem]">
                <li
                  class="text-[#616671] mb-[0.8rem] features-group-li"
                  v-for="desc in item.descList"
                >
                  {{ desc }}
                </li>
              </ul>
            </div>
            <div class="pl-[5.88rem] h-[12.5rem] flex align-center">
              <div
                class="mdsy-product-advantage-title title color-[#272E3B] text-[1.5rem]"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </PageContentCenter>
      </div>
    </section> -->
    <section class="relative w-full flex flex-col items-center relative max-ml:hidden">
      <PageContentCenter class="text-[#1F2329] text-center mt-[5rem] pb-3.5rem absolute z-5">
        <p class="text-[2.13rem]">数字化提效案例</p>
      </PageContentCenter>
      <Pic class="w-[120rem] h-auto relative z-0" src="/images/pages/products/dms/g-00.png" alt="" />
    </section>
    <SiteMap />
  </div>
</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from "vue";
import { useSeoMeta } from 'nuxt/app'
useSeoMeta({
  title: "DMS",
  description: "DMS经销渠道管理平台",
});
const activeIndex = ref(0);
// 添加定时器引用和方向控制
const timer = ref<NodeJS.Timeout | null>(null);
const content = shallowReactive({
  featuresIntroduction: {
    title: "产品介绍",
    desc: "",
    groups: [
      {
        title: "数据实时化",
        desc: "",
        descList: [
          "整合订单、库存、客户信息，形成统一数据中台",
          "为管理层提供实时、准确的渠道洞察仪表盘",
        ],
        icon: "/images/pages/products/dms/1@2x.png",
        mainImage: "/images/pages/products/dms/1-1@2x.png",
        direction: "copywriting-to-image",
      },
      {
        title: "流程自动化",
        desc: "",
        descList: [
          "实现从订单创建、审核、流转到配送确认的全流程在线化、自动化",
          "极大提升操作效率与准确性",
        ],
        icon: "/images/pages/products/dms/2@2x.png",
        mainImage: "/images/pages/products/dms/Frame 1171274930@2x.png",
        direction: "image-to-copywriting",
      },
      {
        title: "协同透明化",
        desc: "",
        descList: [
          "为经销商提供便捷的移动下单入口",
          "开放订单状态实时查询功能",
          "增强渠道伙伴的信任与满意度",
        ],
        icon: "/images/pages/products/dms/3@2x.png",
        mainImage: "/images/pages/products/dms/Frame 1171274939@2x.png",
        direction: "copywriting-to-image",
      },
      {
        title: "决策智能化",
        desc: "",
        descList: [
          "利用大数据分析技术，对销售数据进行多维度分析",
          "为产品规划、库存优化、营销策略提供数据支撑",
          "驱动业务增长",
        ],
        icon: "/images/pages/products/dms/4@2x.png",
        mainImage: "/images/pages/products/dms/Frame 1171274937@2x.png",
        direction: "image-to-copywriting",
      },
    ],
  },
  // advantage: {
  //   title: "数字化提效案例",
  //   list: [
  //     {
  //       title: "第 3 月",
  //       desc: "客户流失率下降",
  //       pre: "25",
  //       descList: [
  //         "客户信息规范",
  //         "客户分类分级分区管理",
  //         "客户精细化运营",
  //         "客户满意度显著提升",
  //       ],
  //       left: "900px",
  //     },
  //     {
  //       title: "第 2 月",
  //       desc: "订单处理时效提升",
  //       pre: "30",
  //       descList: [
  //         "业务员代客下单",
  //         "客户自助下单",
  //         "业务b流程标准制定",
  //         "客户专属规则配置",
  //       ],
  //       left: "980px",
  //     },
  //     {
  //       title: "第 1 月",
  //       desc: "库存周转率提升",
  //       pre: "10",
  //       descList: [
  //         "核心商品SKU线上化建档",
  //         "商品价格（一客一价）设置",
  //         "搭建专属订货商城",
  //         "可售库存线上可视",
  //       ],
  //       left: "600px",
  //     },
  //   ],
  // },
});

// 在组件挂载时启动自动轮播
onMounted(() => { });

// 在组件卸载时清理定时器
onUnmounted(() => {
  if (timer.value) {
    clearInterval(timer.value);
  }
});
</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-dms-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .dms-product-cover {
    background: linear-gradient(119deg, #021054 0%, #01248a 47%, #021054 99%);
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 4px;
        left: 0;
        width: 1.06rem;
        height: 1.06rem;
        background-image: url("/images/pages/products/dms/Frame 1171274835@2x(3).png");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
      }
    }
  }
}

// .mdsy-product-advantage {
//   .mdsy-product-advantage-title {
//     width: 14.25rem;
//     height: 4.88rem;
//     background: url("/images/pages/products/dms/Frame 2147229630@2x.png");
//     background-size: cover;
//     line-height: 4.88rem;
//     padding-left: 6rem;
//   }
//   .mdsy-product-advantage-content {
//     width: 40.13rem;
//     height: 12.5rem;
//     background: url("/images/pages/products/dms/Group 1171274947@2x.png");
//     background-size: cover;
//   }
//   .mdsy-product-advantage-icon {
//     width: 1.48rem;
//     height: 1.97rem;
//     background: url("/images/pages/products/dms/Vector@2x.png");
//     background-size: cover;
//   }
// }</style>
